import React, { useMemo } from 'react';
import NavbarToggle from 'components/NavbarToggle';
import { orderSuccess as TEXT } from 'locales/en';
import ShareActions from '../ShareActions';
import Header from '../Header';
import Button from 'components/Button';
import { useMediaQuery } from 'hooks';
import breakpoints from 'utils/breakpoints';
import PropTypes from 'prop-types';

export const FundraiserConfirmationScreen = (props) => {
  const {
    brand,
    productData,
    productsCount,
    total,
    clientData,
    mobileSummary,
    desktopSummary,
    store,
    orderId
  } = props;

  const isLarge = useMediaQuery(breakpoints.lg);

  const mobileScreen = useMemo(() => {
    return (
      <>
        <NavbarToggle hasHamburgerIcon={false} LogoIcon={brand.Logo} />
        <div className="flex-1 min-h-screen box-border w-full py-24 bg-javelin-background">
          <div className="flex flex-col items-start mt-2 mx-5 mb-5">
            <p className="text-xl text-javelin-gray-dark font-bold mb-2">
              {TEXT.header1(false)}
            </p>
            <p className="text-xs text-black text-opacity-30 mb-5">
              {TEXT.shareOnSocial(productData.name)}
            </p>
            <ShareActions
              productsCount={productsCount}
              amount={total}
              product_url={productData.landing_page_url}
              homepage_url={clientData.homepage_url}
            />
          </div>
          {mobileSummary}
        </div>
      </>
    )
  }, [
    brand.Logo,
    clientData.homepage_url,
    mobileSummary,
    productData.landing_page_url,
    productData.name,
    productsCount,
    total
  ]);

  const desktopScreen = useMemo(() => {
    return (
      <div className="block lg:grid lg:grid-cols-12">
        <div className="lg:flex-1 lg:bg-white lg:min-h-screen lg:pb-8 lg:border lg:border-javelin-gray-border lg:col-span-6 xl:pl-36 xl:col-span-7 lg:pt-20 lg:px-5">
          <Header title={store.data?.name} />
          <div
            data-testid="checkout-details"
            className="lg:pl-0 lg:pr-24 lg:mt-20"
          >
            <p className="text-lg text-javelin-gray-dark font-bold mb-2">
              {TEXT.header1(false)}
            </p>
            <p className="text-sm text-javelin-gray-dark text-opacity-80">
              {TEXT.shareOnSocial(productData.name)}
            </p>
            <ShareActions
              productsCount={productsCount}
              amount={total}
              product_url={productData.landing_page_url}
              homepage_url={clientData.homepage_url}
            />
            <hr className="horizontal-line" />
            <p
              data-testid="order_id"
              className="text-sm font-bold text-opacity-80 text-javelin-gray-dark my-7"
            >
              {orderId}
            </p>
            <hr className="horizontal-line" />
            <p className="text-sm text-javelin-gray-dark text-opacity-80">
              {TEXT.manyCauses}
            </p>
            <Button
              title={TEXT.browse}
              className="btn-blue w-64 px-0 py-4 block text-base mt-7 mb-12"
              onClick={() =>
                window.location.replace(clientData.homepage_url)
              }
            />
          </div>
        </div>
        {desktopSummary}
      </div>
    )
  }, [
    clientData.homepage_url,
    desktopSummary,
    orderId,
    productData.landing_page_url,
    productData.name,
    productsCount,
    store.data?.name,
    total
  ]);

  return isLarge ? desktopScreen : mobileScreen;
}

FundraiserConfirmationScreen.propTypes = {
  brand: PropTypes.object,
  productData: PropTypes.object,
  productsCount: PropTypes.number,
  total: PropTypes.number,
  clientData: PropTypes.object,
  mobileSummary: PropTypes.element,
  desktopSummary: PropTypes.element,
  store: PropTypes.object,
  orderId: PropTypes.string
}
